<template>
  <div v-if="$isLoading" class="loader-container">
    <DotLottieVue
      src="/json/Loader_HIVE.json"
      autoplay
      loop
      background="transparent"
      style="width: 180px; height: 180px"
    />
  </div>
</template>

<script setup lang="ts">
import { DotLottieVue } from '@lottiefiles/dotlottie-vue'
import { useNuxtApp } from '#app'

const { $isLoading } = useNuxtApp()
</script>

<style scoped>
.loader-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  background: white;
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
}
</style>
